import { action } from 'typesafe-actions';
import { RoleState, ROLES_TYPES } from './types';

export const getRoleList = () => action(ROLES_TYPES.GET_ROLELIST_REQUEST);

export const setRoleList = (data: RoleState[]) =>
  action(ROLES_TYPES.SET_DATA_ROLELIST, data);
